import React from "react";
import EditContainer from "../EditContainer";
import { PAGES } from "../../../util/constants/pages";

export const BusinessApprovalEditContainer = () => (
  <EditContainer page={PAGES.BUSINESS_APPROVAL} />
);
